module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "store-dialog",
    attrs: {
      "width": "900px",
      "title": "选择商品",
      "visible": _vm.showDialog,
      "close-on-click-modal": false,
      "before-close": _vm.cancelAction,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [(_vm.params.item_type === 'normal') ? _c('div', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [(!_vm.filter) ? _c('StoreFilter', {
    staticClass: "store",
    attrs: {
      "data": _vm.store
    },
    on: {
      "change": _vm.handleStoreChange
    }
  }) : _vm._e(), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "选中全部",
      "border": ""
    },
    on: {
      "change": _vm.chooseAll
    },
    model: {
      value: (_vm.params.choose_all),
      callback: function($$v) {
        _vm.$set(_vm.params, "choose_all", $$v)
      },
      expression: "params.choose_all"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    staticClass: "input-with-select",
    attrs: {
      "placeholder": "输入商品名称",
      "clearable": ""
    },
    model: {
      value: (_vm.params.keywords),
      callback: function($$v) {
        _vm.$set(_vm.params, "keywords", $$v)
      },
      expression: "params.keywords"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.searchByKey
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    staticClass: "input-with-select",
    attrs: {
      "placeholder": "商品货号",
      "clearable": ""
    },
    model: {
      value: (_vm.params.item_bn),
      callback: function($$v) {
        _vm.$set(_vm.params, "item_bn", $$v)
      },
      expression: "params.item_bn"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.searchByKey
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "选择状态",
      "clearable": ""
    },
    on: {
      "change": _vm.searchByKey
    },
    model: {
      value: (_vm.params.approve_status),
      callback: function($$v) {
        _vm.$set(_vm.params, "approve_status", $$v)
      },
      expression: "params.approve_status"
    }
  }, _vm._l((_vm.statusOption), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-cascader', {
    attrs: {
      "placeholder": "选择标签",
      "filterable": "",
      "options": _vm.tag.list,
      "props": {
        value: 'tag_id',
        label: 'tag_name'
      },
      "clearable": ""
    },
    on: {
      "change": _vm.searchByKey
    },
    model: {
      value: (_vm.select_tags_value),
      callback: function($$v) {
        _vm.select_tags_value = $$v
      },
      expression: "select_tags_value"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.singleData) ? _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.itemsData,
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "选择",
      "width": "70"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-radio', {
          attrs: {
            "label": scope.row.itemId
          },
          nativeOn: {
            "change": function($event) {
              return _vm.getTemplateRow(scope.$index, scope.row)
            }
          },
          model: {
            value: (_vm.templateRadio),
            callback: function($$v) {
              _vm.templateRadio = $$v
            },
            expression: "templateRadio"
          }
        }, [_vm._v(" \n        ")])]
      }
    }], null, false, 3415420613)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "itemId",
      "label": "商品ID",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_bn",
      "label": "货号",
      "width": "70"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(scope.row.item_bn) + "\n      ")]
      }
    }], null, false, 3458743291)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "itemName",
      "label": "商品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "special_type",
      "label": "类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.special_type == 'drug') ? _c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("处方药")]) : _c('span', {
          staticStyle: {
            "color": "blue"
          }
        }, [_vm._v("非处方药")])]
      }
    }], null, false, 2651025645)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "价格",
      "width": "80",
      "formatter": _vm.priceformatter,
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "store",
      "label": "库存",
      "width": "80",
      "show-overflow-tooltip": ""
    }
  })], 1) : _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.itemsData,
      "tooltip-effect": "dark",
      "row-key": _vm.getRowKeys,
      "select-on-indeterminate": false
    },
    on: {
      "select": _vm.handleSelectChange,
      "select-all": _vm.handleSelectAll
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "selectable": _vm.disabledItem,
      "reserve-selection": true,
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "itemId",
      "label": "商品ID",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_bn",
      "label": "货号",
      "width": "70"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(scope.row.item_bn) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "itemName",
      "label": "商品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "special_type",
      "label": "类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.special_type == 'drug') ? _c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("处方药")]) : _c('span', {
          staticStyle: {
            "color": "blue"
          }
        }, [_vm._v("非处方药")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "价格",
      "width": "80",
      "formatter": _vm.priceformatter,
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "store",
      "label": "库存",
      "width": "80",
      "show-overflow-tooltip": ""
    }
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "pager"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelAction
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveStoreAction
    }
  }, [_vm._v("确 定")])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-459fee43", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-459fee43"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/goodsSelect/index.vue
// module id = 2678
// module chunks = 0